module.exports = __webpack_public_path__ + "img/fleets-icon.d9dfb093.svg";